import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import Map from '../views/map/index.vue';
import YxMap from '../views/map/map.vue';
import Map2 from '../views/map/map2.vue';
import Map3 from '@/views/map/map3.vue';
import Test from '@/views/map/test.vue';
import Map4 from '@/views/map/map4.vue';
import Yuxi from '@/views/area/yuxi.vue';
import Main from '@/views/area/main.vue';
import Start from '@/views/area/start.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/yuxi',
    name: 'yuxi',
    component: Main,
  },
  {
    path: '/ht',
    name: 'ht',
    component: () => import('@/views/area/main-ht.vue'),
  },
  {
    path: '/jc',
    name: 'jc',
    component: () => import('@/views/area/main-jc.vue'),
  },
  {
    path: '/cj',
    name: 'cj',
    component: () => import('@/views/area/main-cj.vue'),
  },
  {
    path: '/th',
    name: 'th',
    component: () => import('@/views/area/main-th.vue'),
  },
  {
    path: '/hn',
    name: 'hn',
    component: () => import('@/views/area/main-hn.vue'),
  },
  {
    path: '/ym',
    name: 'ym',
    component: () => import('@/views/area/main-ym.vue'),
  },
  {
    path: '/es',
    name: 'es',
    component: () => import('@/views/area/main-es.vue'),
  },
  {
    path: '/xp',
    name: 'xp',
    component: () => import('@/views/area/main-xp.vue'),
  },
  {
    path: '/yj',
    name: 'yj',
    component: () => import('@/views/area/main-yj.vue'),
  },
  {
    path: '/add-school',
    name: 'add',
    component: () => import('@/views/area/main-add.vue'),
  },
  {
    path: '/school-merge',
    name: 'school-merge',
    component: () => import('@/views/area/main-sub.vue'),
  },

  // {
  //   path: '/echarts',
  //   name: 'Echarts',
  //   component: () => import('../views/TotalCharts/index.vue'),
  //   children: [
  //     // {
  //     //   path: '/kkk',
  //     //   component: () => import('../views/OtherView/index.vue'),
  //     // },
  //     // {
  //     //   path: '/hot',
  //     //   component: () => import('../views/TotalCharts/components/HotChart.vue'),
  //     // },
  //     // {
  //     //   path: '/hot',
  //     //   component: () => import('../views/TotalCharts/components/HotChart.vue'),
  //     // },
  //     // {
  //     //   path: '/map',
  //     //   component: () => import('../views/TotalCharts/components/ChinaMapChart.vue'),
  //     // },
  //     // {
  //     //   path: '/rank',
  //     //   component: () => import('../views/TotalCharts/components/RankChart.vue'),
  //     // },
  //     // {
  //     //   path: '/seller',
  //     //   component: () => import('../views/TotalCharts/components/SellerChart.vue'),
  //     // },
  //     // {
  //     //   path: '/stock',
  //     //   component: () => import('../views/TotalCharts/components/StockChart.vue'),
  //     // },
  //     // {
  //     //   path: '/trend',
  //     //   component: () => import('../views/TotalCharts/components/TrendChart.vue'),
  //     // },
  //   ],
  // },
  // {
  //   path: '/hot',
  //   component: () => import('../views/TotalCharts/components/HotChart.vue'),
  // },
  // {
  //   path: '/echarts/map',
  //   component: () => import('../views/TotalCharts/components/ChinaMapChart.vue'),
  // },
  // {
  //   path: '/rank',
  //   component: () => import('../views/TotalCharts/components/RankChart.vue'),
  // },
  // {
  //   path: '/seller',
  //   component: () => import('../views/TotalCharts/components/SellerChart.vue'),
  // },
  // {
  //   path: '/stock',
  //   component: () => import('../views/TotalCharts/components/StockChart.vue'),
  // },
  // {
  //   path: '/trend',
  //   component: () => import('../views/TotalCharts/components/TrendChart.vue'),
  // },
];

const router = createRouter({
  history: createWebHashHistory(),
  // history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
